<template>
    <!-- 廉洁认证 -->
    <div style="text-align:center !important;height:100px;line-height:100px;">
        <van-button type="info" round @click="toAuth" style="margin-top:20px !important;">廉洁认证</van-button>
    </div>
</template>
<script>
export default {
    data(){
        return{
            
        }
    },
    mounted(){
        document.title='廉洁认证'
    },
    methods:{
        toAuth(){
            // location.href = 'http://edu.sany.com.cn/sty/index.htm'
            // this.$message.error('功能待完成')

            let url = location.protocol=='https:'?
            'https://m3.yunxuetang.cn/e/#/app/exams?funtitle=%E8%80%83%E8%AF%95%E4%B8%AD%E5%BF%83&og=37b6a3ab-44a2-48d3-82b8-ce2d665fb53c'
            :
            'http://edu.sany.com.cn/exam/userallexam.htm'
            location.href = url
        }
    }
}
</script>
<style scoped>
    table,tr,td{
        border:1px solid #D8D8D8;
        padding:5px;
    }
    tr{
        text-align: center;
        height:55px;
    }
</style>